export default __webpack_public_path__ + "static/media/icons8-tiktok.16ad213f.svg";